const $inject = ['$rootScope', '$q', '$timeout', 'moment', 'itinerariesService', 'carSearchService', 'settingsService'];

const cartService = function cartService($rootScope, $q, $timeout, moment, itinerariesService, carSearchService, settingsService) {
  let service = {
    items: [],
    tickets: [],
    add: add,
    remove: remove,
    addToItinerary: addToItinerary,
    cartContainsMatchedFare: cartContainsMatchedFare,
    getTickets: getTickets,
    getTotal: getTotal,
    getCarbonTotal: getCarbonTotal,
    getMatchingTicket: getMatchingTicket,
    getMatchingItemTotal: getMatchingItemTotal,
    addTicket: addTicket,
    removeTicket: removeTicket,
    clear: clear
  };

  function getTotal() {
    let total = 0;

    service.items.forEach(function (item) {
      let itemAmount = 0;

      switch (item.type) {
        case 'flight':
          itemAmount = item.fare.$state.displayMatchedOffset ? item.fare.$state.matchedOffset : item.fare.Amount;

          break;

        case 'rail':
          itemAmount = item.OffsetAmount === undefined ? item.DisplayFare.Amount : item.OffsetAmount;

          break;

        case 'hotel':
          itemAmount = item.rate.TotalAmount;

          break;

        case 'car':
          itemAmount = item.Total;

          break;

        default:
          console.warn("NO CART ITEM TYPE FOUND!");
      }

      total += itemAmount * itinerariesService.totalPaxInCurrentSearch();
    });

    total -= getTicketTotal();

    return total;
  }

  function getCarbonTotal() {
    let total = 0;

    service.items.forEach(function (item) {
      let itemAmount = 0;

      if (item.type === 'flight' && settingsService.settings.CarbonEmissionSetting.IncludeAirEmissionsInTotals) {
          itemAmount = item.fare.CarbonEmissionAmount || 0;
      }

      if (item.type === 'hotel' && settingsService.settings.CarbonEmissionSetting.IncludeHotelEmissionsInTotals) {
        itemAmount = item.hotel.CarbonEmissionAmount || 0;
      }

      if (item.type === 'car' && settingsService.settings.CarbonEmissionSetting.IncludeCarEmissionsInTotals) {
        itemAmount = item.CarbonEmissionAmount || 0;
      }

      total += itemAmount * itinerariesService.totalPaxInCurrentSearch();
    });

    return total;
  }

  function getTicketTotal() {
    return _.reduce(service.tickets, (total, ticket) => {
      return total + ticket.Value;
    }, 0);
  }

  function getTickets() {
    return _.map(service.tickets, (ticket) => {
      return _.extend(ticket, {
        TicketAmount: ticket.Value
      });
    });
  }

  function add(newItem) {
    if (newItem.hasOwnProperty('OptionAutomatic')) {
      if (service.items.length) {
        remove(service.items[0]).then(() => {
          newItem.type = 'car';
          newItem.added = true;
          service.items = [newItem];
        });
      } else {
        newItem.type = 'car';
        newItem.added = true;
        service.items = [newItem];
      }
    }

    if (newItem.hasOwnProperty('hotel')) {
      if (service.items.length) {
        remove(service.items[0]).then(() => {
          newItem.type = 'hotel';
          newItem.room.added = true;
          service.items = [newItem];
        });
      } else {
        newItem.type = 'hotel';
        newItem.room.added = true;
        service.items = [newItem];
      }
    }
  }

  function remove(item) {
    const deferred = $q.defer();
    
    switch (item.type) {
      case 'rail':
        let removeBoth = false;

        if (service.items.length === 2 && item.OffsetAmount === undefined) {
          removeBoth = true;
        }

        _.remove(service.items, function (cartItem) {
          return cartItem === item;
        });

        item.DisplayFare.isSelected = false;
        item.DisplayFare = item.CheapestFare;
        item.parent.itemInCart = false;
        item.row.selected = false;
        item.addedToCart = false;

        $rootScope.$broadcast('cartService:rail:removed');

        deferred.resolve();

        break;

      case 'flight':

        _.remove(service.items, function(cartItem) {
          return cartItem === item;
        });

        if (removeBoth) {
          remove(service.items[0]);
        }

        item.isRemoving = false;

        deferred.resolve();

        break;

      case 'hotel':
        service.items[0].room.added = false;

        delete service.items[0].PolicyCode;
        delete service.items[0].PolicyTitle;
        delete service.items[0].PolicyComments;
        delete service.items[0].LostSavingsAmount;

        item.isRemoving = false;

        clear();

        deferred.resolve();

        break;

      case 'car':
        service.items[0].added = false;

        delete service.items[0].PolicyCode;
        delete service.items[0].PolicyTitle;
        delete service.items[0].PolicyComments;
        delete service.items[0].LostSavingsAmount;
        delete service.items[0].Delivery;
        delete service.items[0].Collection;

        item.isRemoving = false;

        clear();

        deferred.resolve();

        break;

      default:
        console.warn('NO CART ITEM TYPE FOUND!');

        deferred.reject();
    }

    return deferred.promise;
  }

  function addToItinerary(type, items) {
    let cleanedItems = {};

    switch (type) {
      case 'Rails':
        cleanedItems = items.map(item => {
          let railItem = item;

          if (item.DisplayFare) {
            railItem = item.DisplayFare;
          }

          if (item.fareOverride) {
            railItem = item.fareOverride;
          }

          if (item.DisplayFare && item.DisplayFare.selectedAdditional) {
            railItem = item.DisplayFare.selectedAdditional;
          }

          return {
            Carrier: item.row.Carrier,
            RailNumber: item.row.RailNumber,
            Departure: {
              Code: item.row.OriginLocationCode,
              Location: item.row.OriginLocation,
              Date: item.row.DepartureDateTimeOffset
            },
            Arrival: {
              Code: item.row.DestinationLocationCode,
              Location: item.row.DestinationLocation,
              Date: item.row.ArrivalDateTimeOffset
            },
            Detail: {
              Codes: railItem.ResBookDesignCode.join(),
              Rates: railItem.Code.join(),
              RailCardCode: railItem.RailCardCode
            },
            SearchIdentifier: item.row.SearchIdentifier,
            Policy: {}
          }
        });
        break;

      case 'Flights':
        cleanedItems = items.map(item => {
          let policy = null;
          let lostSavingsAmount = null;

          if (item.fare.PolicyException) {
            policy = {
              Code: item.fare.PolicyException.PolicyCode,
              Title: item.fare.PolicyException.PolicyTitle,
              Comments: item.fare.PolicyException.PolicyComments
            };

            lostSavingsAmount = item.fare.PolicyException.LostSavingsAmount;
          }

          return {
            Carrier: item.result.Carrier,
            FlightNumber: item.result.TripNumber,
            Departure: {
              Code: item.result.OriginLocationCode,
              Location: item.result.OriginLocation,
              City: item.result.OriginCity,
              Date: item.result.DepartureDateTimeOffset
            },
            Arrival: {
              Code: item.result.DestinationLocationCode,
              Location: item.result.DestinationLocation,
              City: item.result.DestinationCity,
              Date: item.result.ArrivalDateTimeOffset
            },
            Detail: {
              Codes: item.fare.ResBookDesignCode.join(),
              Rates: item.fare.Code.join()
            },
            SearchIdentifier: item.result.SearchIdentifier,
            LostSavingsAmount: lostSavingsAmount,
            Policy: policy
          }
        });
        break;

      case 'Cars':
        cleanedItems = items.map(C => {
          let policy = null;
          let specialRequests = null;
          let lostSavingsAmount = null;

          if (C.PolicyCode) {
            policy = {
              Code: C.PolicyCode,
              Title: C.PolicyTitle,
              Comments: C.PolicyComments
            }
          }

          if (C.specialRequests) {
            specialRequests = C.specialRequests;
          }

          if (C.LostSavingsAmount) {
            lostSavingsAmount = C.LostSavingsAmount;
          }

          return {
            Supplier: {
              Code: C.Vendor.Code,
              Title: C.Vendor.Title
            },
            Vehicle: {
              Code: C.Code,
              Class: C.Class,
              Title: C.Title
            },
            RateCode: C.RateCode,
            CurrencyCode: C.CurrencyCode,
            PickUp: {
              Date: carSearchService.results.PickUpDate,
              Code: C.PickupLocationCode,
              Location: C.PickupLocation
            },
            DropOff: {
              Date: carSearchService.results.DropOffDate,
              Code: C.DropOffLocationCode,
              Location: C.DropOffLocation
            },
            AvailabilityStatus: C.AvailabilityStatus,
            DeliveryAddress: C.DeliveryAddress,
            CollectionAddress: C.CollectionAddress,
            SearchIdentifier: carSearchService.results.SearchIdentifier,
            Amount: C.Total,
            TaxAmount: 0.0,
            SpecialRequests: specialRequests,
            LostSavingsAmount: lostSavingsAmount,
            Policy: policy
          }
        });

        break;

      case 'Hotels':
        cleanedItems = items.map(item => {
          let currentSearch = itinerariesService.getCurrentSearch();
          let policy = null;
          let paymentNarrative = null;
          let specialRequirements = null;
          let lostSavingsAmount = null;

          if (item.PolicyCode) {
            policy = {
              Code: item.PolicyCode,
              Title: item.PolicyTitle,
              Comments: item.PolicyComments
            }
          }

          if(item.HotelPaymentNarrative) {
            paymentNarrative = {
              Code: item.HotelPaymentNarrative.PaymentCode,
              Title: item.HotelPaymentNarrative.PaymentNarrative,
              Description: item.HotelPaymentNarrative.PaymentInstructions,
              ServiceCode: item.HotelPaymentNarrative.ServiceFeeCode
            }
          }

          if (item.specialRequirements) {
            specialRequirements = item.specialRequirements;
          }

          if (item.LostSavingsAmount) {
            lostSavingsAmount = item.LostSavingsAmount;
          }

          return {
            DateFrom: item.dateFrom,
            DateTo: item.dateTo,
            HotelCode: item.room.HotelCode,
            HotelName: item.hotel.HotelName,
            ChainCode: item.hotel.ChainCode,
            RateCode: item.rate.RateCode,
            RoomName: item.room.RoomName,
            Location: {
              Code: item.hotel.HotelCityCode
            },
            SpecialRequirements: specialRequirements,
            BookingPaymentTypeCode: item.rate.BookingPaymentTypeCode,
            SearchIdentifier: currentSearch.Identifier,
            Amount: item.rate.TotalAmount,
            TaxAmount: item.rate.TaxAmount,
            LostSavingsAmount: lostSavingsAmount,
            Policy: policy,
            PaymentNarrative: paymentNarrative
          }
        });

        break;

      default:
        console.warn("NO TYPE FOUND!");
    }

    return {
      cleanedItems: cleanedItems,
      type: type
    };
  }

  function cartContainsMatchedFare(matchedFares) {
    return containsMatchedFare(service.items, matchedFares);
  }

  function containsMatchedFare(fares, matchedFares) {
    return _.some(fares, (cartItem) => {
      return _.some(matchedFares, (matchedFare) => {
        return matchedFare.Identifier === cartItem.fare.Identifier;
      });
    });
  }

  function getMatchingTicket(ticket) {
    return _.find(service.tickets, (selectedTicket) => {
      return ticket.Carrier === selectedTicket.Carrier && ticket.PassengerIdentifier === selectedTicket.PassengerIdentifier;
    }, 0);
  }

  function getMatchingItemTotal(ticket) {
    return _.reduce(service.items, (total, selectedItem) => {
      const ndcQantasSabre = selectedItem.result.IsNdc && selectedItem.result.Carrier === 'QF' && selectedItem.result.GdsProvider === 'Sabre';
      const sameCarrier = ticket.Carrier === selectedItem.result.Carrier;
      const sameProvider = ticket.GdsProvider === selectedItem.result.GdsProvider;

      return total + (!ndcQantasSabre && sameCarrier && sameProvider ? selectedItem.fare.Amount : 0);
    }, 0);
  }

  function addTicket(ticket) {
    if(ticket.isSelected) {
      return false;
    }

    ticket.isSelected = true;
    service.tickets.push(ticket);
  }

  function removeTicket(ticket) {
    ticket.isSelected = false;

    service.tickets = _.reject(service.tickets, selectedTicket => {
      return selectedTicket === ticket;
    });
  }

  function clear() {
    service.items = [];
    service.tickets = [];
  }

  return service;
};


cartService.$inject = $inject;

export default cartService;



// WEBPACK FOOTER //
// ./src/services/cartService.js